/**
 * Slugs de rôles historiquement prévus en base / référencés dans l’app (libellés UI, listes).
 * La colonne `user_roles.role_type` est du TEXT : tout slug snake_case unique peut être créé depuis l’admin.
 */
export const ROLE_TYPE_SLUG_MAX_LENGTH = 100;

/** snake_case : commence par une lettre ; segments [a-z0-9]+ séparés par un seul underscore */
export const ROLE_TYPE_SLUG_REGEX = /^[a-z][a-z0-9]*(_[a-z0-9]+)*$/;

export function normalizeRoleTypeSlug(value) {
  if (value == null || typeof value !== 'string') return '';
  return value.trim().toLowerCase();
}

export function isValidRoleTypeSlug(value) {
  const s = normalizeRoleTypeSlug(value);
  if (!s || s.length > ROLE_TYPE_SLUG_MAX_LENGTH) return false;
  return ROLE_TYPE_SLUG_REGEX.test(s);
}

export const KNOWN_DB_USER_ROLE_TYPES = [
  'administrator',
  'dentist_client',
  'dentist_supplier',
  'distributor',
  'production_supplier',
  'production_responsible',
  'logistics_coordinator',
  'operators',
  'operator_3d',
  'operator_thermo',
  'operator_finition',
  'operator_qualite',
  'livraison',
  'agent_administratif',
  'coursier',
];

/** Libellés pour la liste déroulante (slug technique → nom compréhensible). */
const LABELS_FR = {
  administrator: 'Administrateur',
  dentist_client: 'Dentiste client',
  dentist_supplier: 'Prothésiste / fournisseur',
  distributor: 'Distributeur',
  production_supplier: 'Fournisseur production',
  production_responsible: 'Responsable production',
  logistics_coordinator: 'Coordinateur logistique',
  operators: 'Opérateur (legacy)',
  operator_3d: 'Opérateur 3D',
  operator_thermo: 'Opérateur thermo',
  operator_finition: 'Opérateur finition',
  operator_qualite: 'Opérateur qualité',
  livraison: 'Livraison / expédition',
  agent_administratif: 'Agent administratif',
  coursier: 'Coursier',
};
const LABELS_EN = {
  administrator: 'Administrator',
  dentist_client: 'Dentist client',
  dentist_supplier: 'Dentist supplier',
  distributor: 'Distributor',
  production_supplier: 'Production supplier',
  production_responsible: 'Production lead',
  logistics_coordinator: 'Logistics coordinator',
  operators: 'Operator (legacy)',
  operator_3d: '3D operator',
  operator_thermo: 'Thermo operator',
  operator_finition: 'Finishing operator',
  operator_qualite: 'Quality operator',
  livraison: 'Shipping / delivery',
  agent_administratif: 'Administrative agent',
  coursier: 'Courier',
};

/**
 * @param {string} language 'FR' | 'EN' | 'PL'
 * @param {string} roleType slug
 */
export function getRoleTypeSelectLabel(language, roleType) {
  const lg = typeof language === 'string' ? language.toUpperCase() : 'FR';
  const map = lg === 'EN' ? LABELS_EN : LABELS_FR;
  return map[roleType] || roleType?.replace(/_/g, ' ') || '';
}
